import { API, graphqlOperation } from "aws-amplify";
import { configurePlusAppsync, configureGenericAppSync } from 'src/context/AuthContextUtility';


export const getDocumentFromVault = async (content_type, service, service_params) => {

    await configurePlusAppsync()
    const variables = {
        content_type,
        service,
        service_params: JSON.stringify(service_params)
    };
    let qry = `query MyQuery(
    $content_type: String!
    $service: String!
    $service_params: AWSJSON!
  ) {
    getDocumentFromVault(
      content_type: $content_type
      service: $service
      service_params: $service_params
    ) {
      fileUrl
    }
  }
      `
  let response = await API.graphql(graphqlOperation(qry, variables))
  await configureGenericAppSync()
  return response.data.getDocumentFromVault;

}

export const uploadDocumentToVault = async (content_type, service, service_params, file) => {

    if(!service_params.hasOwnProperty('tagging')){
      service_params["tagging"] = "service=" + service
    }
    await configurePlusAppsync()
    const variables = {
    content_type,
    service,
    service_params: JSON.stringify(service_params)
  };
    let qry = `mutation MyMutation(
    $content_type: String!
    $service: String!
    $service_params: AWSJSON!
  ) {
    uploadDocumentToVault(
      content_type: $content_type
      service: $service
      service_params: $service_params
    ) {
      objectKey
      uploadUrl
    }
  }
    `
  let response = await API.graphql(graphqlOperation(qry, variables))
  let result = response.data.uploadDocumentToVault

  let fetchResp;
  try {
    fetchResp = await fetch(result.uploadUrl, {
      method: "PUT",
      headers: { "Content-Type": `application/${content_type}`,
                 "x-amz-tagging": service_params["tagging"],
                 "x-amz-acl": "bucket-owner-full-control" },
      body: file
    });
  } finally {
    await configureGenericAppSync();
  }
  if (!fetchResp.ok) {
    throw new Error(`Vault upload failed: ${fetchResp.status} ${fetchResp.statusText}`);
  }
  return response.data.uploadDocumentToVault;
}

export const removeDocumentFromVault = async (content_type, service, service_params) => {

    await configurePlusAppsync()
    const variables = {
        content_type,
        service,
        service_params: JSON.stringify(service_params)
    };
    let qry = `mutation MyMutation(
    $content_type: String!
    $service: String!
    $service_params: AWSJSON!
  ) {
    removeDocumentFromVault(
      content_type: $content_type
      service: $service
      service_params: $service_params
    ) {
      fileUrl
    }
  }
      `
  let response = await API.graphql(graphqlOperation(qry, variables))
  let result = response.data.removeDocumentFromVault;
  await fetch(result.fileUrl, {
    method: "DELETE"
  });
  await configureGenericAppSync()
}